import React from "react";

import RegisterEditForm from "../RegisterEditForm/View";

const Register = ({ userState, actions }) => {
  return (
    <RegisterEditForm
      isAddUser={true}
      userState={userState}
      actions={actions}
    />
  );
};

export default Register;
